import React from 'react';
import LordIcon from '../../components/LordIcon';
import LORDICONS from '../../lordicons';

type HomeIconProps = {
  name: keyof typeof LORDICONS;
  size?: number;
  color?: string;
  hoverColor?: string;
  trigger?: 'hover' | 'loop-on-hover' | 'in' | 'loop';
  /** Wrap in the blue circular badge used on the landing. */
  badge?: boolean;
  badgeSize?: number;
  className?: string;
  target?: string;
};

/** Landing-page LordIcon with optional circular badge. */
export const HomeIcon: React.FC<HomeIconProps> = ({
  name,
  size = 20,
  color = '#0065F4',
  hoverColor,
  trigger = 'hover',
  badge = false,
  badgeSize = 38,
  className,
  target,
}) => {
  const icon = (
    <LordIcon
      src={LORDICONS[name]}
      trigger={trigger}
      size={size}
      color={color}
      hoverColor={hoverColor}
      target={target}
      className={className}
    />
  );
  if (!badge) return icon;
  return (
    <span
      style={{
        width: badgeSize,
        height: badgeSize,
        flex: 'none',
        borderRadius: 999,
        background: '#EAF1FF',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {icon}
    </span>
  );
};

export default HomeIcon;
